export enum ValidationType {
  numeric,
  alpha,
  alphaNum,
  email,
  required,
}
